module["exports"] = [
  "NV",
  "BVBA",
  "CVBA",
  "VZW"
];
